// import { ApiService } from 'src/app/services/api/api.service';
import { Injectable, Optional } from '@angular/core';
import {
  Auth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  EmailAuthProvider,
  AuthCredential,
  reauthenticateWithCredential,
  updatePassword,
  sendPasswordResetEmail
} from '@angular/fire/auth';

import { ToastController } from '@ionic/angular';
import { FirebaseError } from 'firebase/app';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AuthState, create_user, new_user } from './auth.model';
import { jwtDecode } from 'jwt-decode';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import "firebase/auth";
import { UserService } from '../user.service';
import { ToastService } from '../toast.service';
import { ApiService } from '../api/api.service';
import { EventsService } from '../events.service';


const initialAuthState: AuthState = {
  isLoggedIn: false,
  isEmailVerified: false,
  id: null,
  email: null,
  name: null,
  username: null,
  first_name: null,
  last_name: null,
  phone_number: null,
  token: null,
  avatar: null,
  cover_photo: null,
  role: null,
};
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  UserObj: any;
  firebaseUser:any;
  //Loaders
  private isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  readonly isLoading$ = this.isLoading.asObservable();

  //Auth State Management
  private readonly _authState = new BehaviorSubject<AuthState>(
    initialAuthState
  );
  readonly auth$ = this._authState.asObservable();
 
  constructor(
    @Optional() private auth: Auth,
    private http: HttpClient,
    private toast: ToastController,
    private router: Router,
   private userservice:UserService,
   private toastService:ToastService,
   private apiService:ApiService,
   private events:EventsService,
   
  ) {
    // Delay updateState to run outside of constructor to avoid injection context warning
    setTimeout(() => {
      this.updateState();
    }, 0);
 
   }
   updateState(){
    // Check if auth is available before setting up listeners
    if (!this.auth) {
      console.error('Firebase Auth is not initialized');
      return;
    }
       // this.auth.settings. = 300000;
  
    
       this.auth.onIdTokenChanged((user) => {
        this.firebaseUser=user;
        console.log("firebase user::::",user);
        if(user){
          
          // user.getIdToken().then(token => {
          //   console.log(token);
           
          // });
        //  console.log(user.refreshToken);
          user.getIdToken(true).then((token) => {
 
            // console.log('token is updated',token);
            localStorage.setItem('token',token)
            const token_decoded: any = jwtDecode(token);
            // Load user data from localStorage (backend data)
            this.UserObj=JSON.parse(localStorage.getItem('user') || '{}');
            console.log("UserObj::::",this.UserObj);
            
            const u: AuthState = {
              isLoggedIn: true,
              isEmailVerified: user.emailVerified,
              id: this.UserObj.id || user.uid,
              email: this.UserObj.email || user.email,
              name: this.UserObj.username || user.displayName,
              username: this.UserObj.username || user.displayName,
              first_name: this.UserObj.first_name || null,
              last_name: this.UserObj.last_name || null,
              phone_number: user.phoneNumber,
              token,
              avatar: this.UserObj.avatar || user.photoURL,
              role: this.UserObj.role_id || token_decoded.role,
              cover_photo: 'https://www.indiewire.com/wp-content/uploads/2022/05/37507-original.jpeg',
            };
            this._authState.next(u);
            this.isLoading.next(false);
          }).catch(error => {
            console.error('Error getting token:', error);
            this.isLoading.next(false);
          });
        }
      });
  
      this.auth.onAuthStateChanged((user) => {
        if(!user){
          this.isLoading.next(false);
          this._authState.next(initialAuthState);
          return;
        }
        
        user.getIdToken(true).then((token) => {
          const token_decoded: any = jwtDecode(token);
          
          // Load user data from localStorage (backend data)
          this.UserObj=JSON.parse(localStorage.getItem('user') || '{}');
         
          const u: AuthState = {
            isLoggedIn: true,
            isEmailVerified: user.emailVerified,
            id: this.UserObj.id || user.uid,
            email: this.UserObj.email || user.email,
            name: this.UserObj.username || user.displayName,
            username: this.UserObj.username || user.displayName,
            first_name: this.UserObj.first_name || null,
            last_name: this.UserObj.last_name || null,
            phone_number: user.phoneNumber,
            token,
            avatar: this.UserObj.avatar || user.photoURL,
            role: this.UserObj.role_id || token_decoded.role,
            cover_photo: 'https://www.indiewire.com/wp-content/uploads/2022/05/37507-original.jpeg',
          };
          console.log("AuthState::::",u);
          this._authState.next(u);
          this.isLoading.next(false);
        }).catch(error => {
          console.error('Error getting token:', error);
          this.isLoading.next(false);
        });
  
      });
   }

  // async registerAccountWithEmailPassword(user: create_user) {
  //   this.isLoading.next(true);
  //   createUserWithEmailAndPassword(this.auth, user.email, user.password)
  //   .then(async (data) => {
  //     data.user.getIdToken(true).then(async (token) => {
  //       const token_decoded: any = jwtDecode(token);
  //       if(!token_decoded.role){
  //         const u: new_user = {
  //           uid: data.user.uid,
  //           name: user.name,
  //           email: data.user.email,
  //           role: user.role
  //         };
  //         await this.post('auth?type=new-user', u, token).pipe(take(1)).subscribe(async (res) => {
  //           if(res){
  //             this.isLoading.next(false);
  //             await data.user.getIdToken(true);
  //             await this.router.navigate(['home'], {replaceUrl: true});
  //           }
  //           }, async (err) => {
  //             const t = await this.toast.create({
  //                 header: 'Error',
  //                 message: 'There was an issue creating this new user. Please try again shortly.',
  //                 position: 'bottom',
  //                 duration: 5000,
  //                 color: 'danger'
  //             });
  //             await t.present();
  //             this.isLoading.next(false);
  //         });
  //       }
  //     });
  //   })
  //   .catch(async (err: FirebaseError) => {
  //     this.isLoading.next(false);
  //     if(err.code === 'auth/email-already-in-use'){
  //       const toast = await this.toast.create({
  //         header: 'User already exists',
  //         message: 'A user with this email address already exists, please log in instead of creating a new account.',
  //         position: 'bottom',
  //         duration: 3000
  //       });
  //       await toast.present();
  //     } else {
  //       const toast = await this.toast.create({
  //         header: `Error: ${err.code}`,
  //         message: 'There was a problem creating your new account. Try again later or contact our support team.',
  //         position: 'bottom',
  //         duration: 3000
  //       });
  //       await toast.present();
  //     }

  //   });
  // }

  async loginWithEmailPassword(email: string, password: string){
    this.isLoading.next(true);
    signInWithEmailAndPassword(this.auth, email, password)
    .then((user: any) => {
      // console.log('user ====>', user);
      localStorage.setItem('token',user.user.accessToken)
      // console.log(user.user.accessToken);
      this.apiService.get('users/show-profile').subscribe(res=>{
        localStorage.setItem('role',res.data.role_id)
        localStorage.setItem('user',JSON.stringify(res.data));
        this.UserObj=res.data;
        //  
      
        this.events.publish('user:login', true);
        if(res.data){
          this.router.navigate(['home']);
          this.isLoading.next(false);
        }
        else
        {
          this.toastService.presentErrorToast('user does not exist in DB');
          this.isLoading.next(false);
          this.logout();
        }
      },error=>{
        this.isLoading.next(false);
        this.logout();
      });

    
      // this.router.navigate(['home']);
    })
    .catch(async (err: FirebaseError) => {
      this.isLoading.next(false);
      if(err.code === 'auth/wrong-password'){
        const toast = await this.toast.create({
          header: 'Wrong Password',
          message: 'Password provided does not match with the identity already registered. Please add the valid password and try again.',
          position: 'bottom',
          duration: 3000,
          color: 'danger'
        });
        await toast.present();
      } else if (err.code === 'auth/user-not-found'){
        const toast = await this.toast.create({
          header: 'No user found',
          message: 'With provided credentials, we could not find any user registered. Please sign up your new account and try again.',
          position: 'bottom',
          duration: 3000,
          color: 'danger'
        });
        await toast.present();
      }
    });
  }

  async logout(){
    await signOut(this.auth).then(()=>{
      // this.storage.clear();
      localStorage.clear();
    })
    
  }

  async forgotPassword(email: string){
    await this.isLoading.next(true);
    await this.postWithoutToken('users/forgot-password', {email}).pipe(take(1)).subscribe(async (res) => {
      if ( res.success ) {
        const successToast = await this.toast.create({
          header: 'Email sent',
          message: 'Email has been sent to your email address',
          position: 'bottom',
          duration: 3000,
          color: 'success'
        });
        await successToast.present();
      } else {
        const errorToast = await this.toast.create({
          header: 'Error',
          message: 'User doesn\'t exist',
          position: 'bottom',
          duration: 3000,
          color: 'danger'
        });
        await errorToast.present();
      }
    }, async (err) => {
      const errorToast = await this.toast.create({
        header: 'Error',
        message: 'There was an issue sending email. Please try again shortly.',
        position: 'bottom',
        duration: 5000,
        color: 'danger'
      });
      await errorToast.present();
      this.isLoading.next(false);
    });
  }

  private post(url: string, body: any, token: string): Observable<any>{
    const headers = {
      'Content-Type': 'application/json',
      Authorization: token
    };
    return this.http.post(environment.api_url + url, body);
  }

  private postWithoutToken( url: string, body: any): Observable<any>{
    const headers = {
      'Content-Type': 'application/json'
    };
    return this.http.post(environment.api_url + url, body);
  }
  
  async updatePassword(
    oldPassword: string,
    newpassword: string
  ): Promise<void> {
    let user=this.auth.currentUser;
    try {
      const credential = EmailAuthProvider.credential(
        this.firebaseUser.email,
        oldPassword
      );
      // console.log(credential);
      await this.reAuthenticateUser(user,credential);
      return updatePassword(user,newpassword);
    } catch (error) {
      return Promise.reject(error);
    }
  }
  private async reAuthenticateUser(
    user:any,
    credential: AuthCredential
  ): Promise<void> {
    try {
      await reauthenticateWithCredential(user,credential);
      return;
    } catch (error) {
      return Promise.reject(error);
    }
  }


  getToken(){
    return localStorage.getItem('token')
  }
  refreshToken(){
    this.auth.onIdTokenChanged((user) => {
      this.firebaseUser=user;
      // console.log(user);
      if(user){

      //  console.log(user.refreshToken);
        user.getIdToken(true).then((token) => {
          return token
        })}
      });
          
  }
}
